import { set } from "lodash";
import Kithara from "src/services/kithara";
import { cloneDeep } from "lodash";
const kithara = new Kithara();

// default item with a song_version to force PlaylistItemEdit.vue to react to changes of song_version
const defaultPlaylistItem = {
  caption: "",
  song_version: null
};
export default {
  state: {
    list: {
      loading: false,
      complete: false,
      errors: [],
      playlistItems: [],
      nextPage: 1,
      pageSize: 1000,
      filter: ""
    },
    editing: {
      pending: true,
      errors: [],
      playlistItem: cloneDeep(defaultPlaylistItem)
    }
  },
  mutations: {
    PLAYLIST_ITEMS_LIST_CLEAN: state => {
      state.list.playlistItems = [];
      state.list.nextPage = 1;
      state.list.complete = false;
    },
    PLAYLIST_ITEMS_LIST: state => {
      state.list.loading = true;
    },
    PLAYLIST_ITEMS_LIST_SUCCESS: (state, payload) => {
      state.list.loading = false;
      state.list.playlistItems = payload.playlistItems;
      state.list.complete = payload.complete;
      state.list.nextPage++;
    },
    PLAYLIST_ITEMS_LIST_FAILED: (state, payload) => {
      state.list.loading = false;
      state.list.errors = payload;
    },
    PLAYLIST_ITEMS_SELECT: state => {
      state.editing.pending = false;
      state.editing.playlistItem = cloneDeep(defaultPlaylistItem);
    },
    PLAYLIST_ITEMS_SET_SELECTED: (state, payload) => {
      state.editing.pending = false;
      state.editing.playlistItem = payload;
    },
    PLAYLIST_ITEMS_UPDATE_SELECTED: (state, { path, value }) => {
      state.editing.pending = false;
      set(state.editing.playlistItem, path, value);
    },
    PLAYLIST_ITEMS_UPDATE_SELECTED_IN_LIST: state => {
      for (let i = 0; i < state.list.playlistItems.length; i++) {
        if (
          state.list.playlistItems[i].id ===
          parseInt(state.editing.playlistItem.id)
        ) {
          state.list.playlistItems[i] = state.editing.playlistItem;
        }
      }
    },
    PLAYLIST_ITEMS_ADD_SELECTED_TO_LIST: state => {
      state.list.playlistItems.push(state.editing.playlistItem);
    },
    PLAYLISTITEM_READY: state => {
      state.editing.pending = false;
    },
    PENDING_PLAYLISTITEM: state => {
      state.editing.pending = true;
    },
    PLAYLIST_ITEMS_SELECT_FAILED: () => {
      // do nothing because it should not happen
    },
    PLAYLIST_ITEMS_UPDATE: state => {
      state.editing.pending = true;
    },
    PLAYLIST_ITEMS_UPDATE_SUCCESS: state => {
      state.editing.playlistItem = cloneDeep(defaultPlaylistItem);
      state.editing.pending = false;
    },
    PLAYLIST_ITEMS_UPDATE_FAILED: (state, payload) => {
      state.editing.playlistItem = cloneDeep(defaultPlaylistItem);
      state.editing.pending = false;
      state.editing.errors = payload;
    },
    PLAYLIST_ITEMS_SET: (state, playlistItems) => {
      state.list.playlistItems = playlistItems;
    },
    SET_PLAYLISTITEM_CAPTION: (state, caption) => {
      state.editing.playlistItem.caption = caption;
    },
    SET_PLAYLISTITEM: (state, item) => {
      state.editing.playlistItem = item;
    }
  },
  actions: {
    refreshPlaylistItems({ commit }) {
      commit("PLAYLIST_ITEMS_LIST_CLEAN");
    },
    setPlayListItemCaption({ state, commit }, caption) {
      if (state.editing.playlistItem)
        commit("SET_PLAYLISTITEM_CAPTION", caption);
    },
    setPlaylistItem({ commit }, item) {
      commit("SET_PLAYLISTITEM", item);
    },
    loadMorePlaylistItems({ state, commit, rootState }) {
      if (!state.list.loading && !state.list.complete) {
        commit("PLAYLIST_ITEMS_LIST");
        const { nextPage, pageSize, filter } = state.list;
        return kithara
          .getPlaylistItems(
            rootState.route.params.playlistId,
            nextPage,
            pageSize,
            "position|asc",
            filter
          )
          .then(response => {
            const { data } = response.data;
            const lastPage = response.data.links.pagination.last_page;
            commit("PLAYLIST_ITEMS_LIST_SUCCESS", {
              playlistItems: state.list.playlistItems.concat(data),
              complete: lastPage === 0 || nextPage === lastPage
            });
          })
          .catch(err => commit("PLAYLIST_ITEMS_LIST_FAILED", [err]));
      }
    },
    loadAllPlaylistItems({ state, commit, rootState }) {
      if (!state.list.loading && !state.list.complete) {
        commit("PLAYLIST_ITEMS_LIST_CLEAN"); // clean the whole list, we will load all at once
        const { filter } = state.list;
        return kithara
          .getPlaylistItems(
            rootState.route.params.playlistId,
            1,
            -1,
            "position|asc",
            filter
          )
          .then(response => {
            const { data } = response.data;
            commit("PLAYLIST_ITEMS_LIST_SUCCESS", {
              playlistItems: data, // no need to concat, this should be the complete list.
              complete: true
            });
          })
          .catch(err => commit("PLAYLIST_ITEMS_LIST_FAILED", [err]));
      }
    },
    setCurrentPlayListItem({ commit }, item) {
      commit("PLAYLIST_ITEMS_SET_SELECTED", item);
    },
    fetchPlaylistItems({ state, commit }, playlistId) {
      if (!state.list.loading && !state.list.complete) {
        commit("PLAYLIST_ITEMS_LIST");
        const { nextPage, pageSize, filter } = state.list;
        return kithara
          .getPlaylistItems(
            playlistId,
            nextPage,
            pageSize,
            "position|asc",
            filter
          )
          .then(response => {
            const { data } = response.data;
            const lastPage = response.data.links.pagination.last_page;
            commit("PLAYLIST_ITEMS_LIST_SUCCESS", {
              playlistItems: state.list.playlistItems.concat(data),
              complete: lastPage === 0 || nextPage === lastPage
            });
          })
          .catch(err => commit("PLAYLIST_ITEMS_LIST_FAILED", [err]));
      }
    },
    fetchPlayListItem({ state, commit, rootState }, { playlistId, itemId }) {
      // 1- Check playlistItem from store
      if (itemId === state.editing.playlistItem.id) {
        return state.editing.playlistItem;
      }

      commit("PENDING_PLAYLISTITEM");
      // 2- Check in playlistItems from store
      const itemFromStore = rootState.playlistItems.list.playlistItems.find(
        item => item.id === itemId
      );
      if (itemFromStore) {
        commit("SET_PLAYLISTITEM", itemFromStore);
        commit("PLAYLISTITEM_READY");
        return itemFromStore;
      }

      // 3- Get it from the db
      const { nextPage, pageSize, filter } = state.list;
      return kithara
        .getPlaylistItems(
          playlistId,
          nextPage,
          pageSize,
          "position|asc",
          filter
        )
        .then(resp => {
          const items = resp.data.data;
          const expectedItem = items.find(item => item.id == itemId);
          const returnedItem = expectedItem ? expectedItem : {};
          commit("SET_PLAYLISTITEM", returnedItem);
          commit("PLAYLISTITEM_READY");
          return returnedItem;
        });
    },
    selectPlaylistItem({ state, commit, rootState, dispatch }) {
      return dispatch("loadAllPlaylistItems").then(() => {
        commit("PLAYLIST_ITEMS_SELECT");
        for (let i = 0; i < state.list.playlistItems.length; i++) {
          if (
            state.list.playlistItems[i].id ===
            parseInt(rootState.route.params.playlistItemId)
          ) {
            commit("PLAYLIST_ITEMS_SET_SELECTED", state.list.playlistItems[i]);
            return; // playlist_item found
          }
        }
        commit(
          "PLAYLIST_ITEMS_SELECT_FAILED",
          new Error(
            "Could not find playlistItem with id " +
              rootState.route.params.playlistItemId
          )
        );
      });
    },
    createPlaylistItem({ state, commit, rootState, dispatch }) {
      return dispatch("loadAllPlaylistItems").then(() => {
        commit("PLAYLIST_ITEMS_UPDATE");
        commit("PLAYLIST_ITEMS_ADD_SELECTED_TO_LIST");
        return kithara
          .updatePlaylistItems(
            rootState.route.params.playlistId,
            state.list.playlistItems
          )
          .then(() => {
            commit("PLAYLIST_ITEMS_UPDATE_SUCCESS");
            commit("PLAYLIST_ITEMS_LIST_CLEAN");
          })
          .catch(err => commit("PLAYLIST_ITEMS_UPDATE_FAILED", [err]));
      });
    },
    savePlaylistItem({ state, commit, rootState, dispatch }) {
      return dispatch("loadAllPlaylistItems").then(() => {
        commit("PLAYLIST_ITEMS_UPDATE");
        commit("PLAYLIST_ITEMS_UPDATE_SELECTED_IN_LIST");
        return kithara
          .updatePlaylistItems(
            rootState.route.params.playlistId,
            state.list.playlistItems
          )
          .then(() => {
            commit("PLAYLIST_ITEMS_UPDATE_SUCCESS");
            commit("PLAYLIST_ITEMS_LIST_CLEAN");
          })
          .catch(err => commit("PLAYLIST_ITEMS_UPDATE_FAILED", [err]));
      });
    },
    updatePlaylistItem({ commit }, payload) {
      commit("PLAYLIST_ITEMS_UPDATE_SELECTED", payload);
    },
    removePlaylistItem(
      { commit, dispatch, state },
      { playlistId, playlistItemId }
    ) {
      const playlistItems = state.list.playlistItems.filter(
        elem => elem.id != playlistItemId
      );
      commit("PLAYLIST_ITEMS_UPDATE");
      commit("PLAYLIST_ITEMS_SET", playlistItems);
      return kithara
        .updatePlaylistItems(playlistId, playlistItems)
        .then(() => {
          commit("PLAYLIST_ITEMS_UPDATE_SUCCESS");
        })
        .catch(err => {
          commit("PLAYLIST_ITEMS_UPDATE_FAILED", [err]);
          dispatch("refreshPlaylistItems");
          dispatch("loadMorePlaylistItems");
        });
    },
    updatePlaylisItemsOrder({ commit, rootState }, playlistItems) {
      commit("PLAYLIST_ITEMS_UPDATE");
      commit("PLAYLIST_ITEMS_SET", playlistItems);
      return kithara
        .updatePlaylistItems(rootState.route.params.playlistId, playlistItems)
        .then(() => {
          commit("PLAYLIST_ITEMS_UPDATE_SUCCESS");
        })
        .catch(err => commit("PLAYLIST_ITEMS_UPDATE_FAILED", [err]));
    }
  },
  getters: {
    playlistItems: state => state.list.playlistItems,
    playlistItemsLoading: state => state.list.loading,
    playlistItemsComplete: state => state.list.complete,
    selectedPlaylistItem: state => state.editing.playlistItem,
    selectedPlaylistItemTags: state =>
      state.editing.playlistItem.template_item
        ? state.editing.playlistItem.template_item.tags
        : []
  }
};



// WEBPACK FOOTER //
// ./src/store/playlistItems.js